import React from 'react';
import { features } from '../data/mock';
import { Layers, Zap, Coins, Clock, Wallet, ArrowLeftRight } from 'lucide-react';

const iconMap = {
  0: Layers,
  1: Zap,
  2: Coins,
  3: Clock,
  4: Wallet,
  5: ArrowLeftRight,
};

const Features = () => {
  return (
    <section className="py-24 bg-[#0b0014]">
      <div className="max-w-[1400px] mx-auto px-6">
        <p className="text-purple-400 font-medium text-center mb-2">Layer 1 Blockchain</p>
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-4">
          Why Stocks Protocol?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          {features.map((feature, index) => {
            const Icon = iconMap[index];
            return (
              <div 
                key={index}
                className="group p-8 bg-gradient-to-b from-white/[0.03] to-transparent border border-white/[0.06] rounded-2xl hover:border-purple-500/30 transition-all duration-300"
              >
                <div className="w-12 h-12 bg-purple-500/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-purple-500/20 transition-colors">
                  <Icon className="w-6 h-6 text-purple-400" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
